import { Box, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ModalInfoItemProps {
  title: string;
  info: ReactNode;
  dataTestId?: string;
}

const ModalInfoItem = ({ title, info, dataTestId }: ModalInfoItemProps) => {
  return (
    <Box data-testid={dataTestId}>
      <Text fontWeight="bold">{title}</Text>
      {info}
    </Box>
  );
};

export default ModalInfoItem;
